import { render, staticRenderFns } from "./php.vue?vue&type=template&id=7cd1a419&scoped=true"
import script from "./php.vue?vue&type=script&lang=js"
export * from "./php.vue?vue&type=script&lang=js"
import style0 from "./php.vue?vue&type=style&index=0&id=7cd1a419&prod&lang=css"
import style1 from "./php.vue?vue&type=style&index=1&id=7cd1a419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1a419",
  null
  
)

export default component.exports